import script from "./SubscriberPdfForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriberPdfForm.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriberPdfForm.vue?vue&type=style&index=0&id=525246b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525246b6"]])

export default __exports__